import type { Airflow } from '@aviata/platform-types';

export const getDiscountText = (discount: Airflow.Offer.Discount) => {
  return discount.title;
};
